
import React from 'react';
import { motion, AnimatePresence } from 'motion/react';
import { Package } from 'lucide-react';

interface SplashScreenProps {
  isLoading: boolean;
  logoUrl?: string | null;
}

export const SplashScreen: React.FC<SplashScreenProps> = ({ isLoading, logoUrl }) => {
  return (
    <AnimatePresence>
      {isLoading && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.8, ease: "easeInOut" }}
          className="fixed inset-0 z-[100000] bg-white flex flex-col items-center justify-center overflow-hidden"
        >
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.5, ease: "easeOut" }}
            className="relative flex flex-col items-center"
          >
            {logoUrl ? (
              <motion.img
                src={logoUrl}
                alt="Logo"
                className="h-24 w-auto object-contain mb-8"
                animate={{ 
                  scale: [1, 1.05, 1],
                }}
                transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
              />
            ) : (
              <motion.div 
                className="w-24 h-24 bg-slate-900 rounded-[2.5rem] flex items-center justify-center mb-8 shadow-2xl"
                animate={{ 
                  rotate: [0, 5, -5, 0],
                  scale: [1, 1.02, 0.98, 1]
                }}
                transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
              >
                <Package size={48} className="text-white" strokeWidth={1.5} />
              </motion.div>
            )}

            <div className="space-y-4 text-center">
              <h1 className="text-2xl font-black text-slate-900 tracking-tight">رائد الخير</h1>
              <div className="flex items-center justify-center gap-1.5">
                <motion.div 
                  className="w-1.5 h-1.5 bg-indigo-600 rounded-full"
                  animate={{ opacity: [0, 1, 0] }}
                  transition={{ duration: 1, repeat: Infinity, delay: 0 }}
                />
                <motion.div 
                  className="w-1.5 h-1.5 bg-indigo-600 rounded-full"
                  animate={{ opacity: [0, 1, 0] }}
                  transition={{ duration: 1, repeat: Infinity, delay: 0.2 }}
                />
                <motion.div 
                  className="w-1.5 h-1.5 bg-indigo-600 rounded-full"
                  animate={{ opacity: [0, 1, 0] }}
                  transition={{ duration: 1, repeat: Infinity, delay: 0.4 }}
                />
              </div>
            </div>
          </motion.div>

          <footer className="absolute bottom-12 text-[10px] font-black text-slate-300 uppercase tracking-[0.3em]">
            Enterprise Logistics v4.3
          </footer>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
